import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Table from 'components/shared/table';
import { Button } from 'ui';
import { AssociatedContent } from '../../../AssociatedContent/types';
import * as types from '../../types';
import AssignContent from './AssignContent';

const UnregisteredRow = ({
  addGuest,
  associatedContent: { contentItems },
  attendanceErrors,
  event,
  user,
}) => {
  const [assignContent, setAssignContent] = useState(true);
  const showAssignContent =
    !event.is_archived &&
    !!contentItems.length > 0 &&
    contentItems.every(item => item.assigned_at);

  return (
    <Table.Row>
      <Table.Body.Cell size="xl" contentClassName="d-f jc-sb fd-r ai-c fw-w">
        <span>{user.name}</span>
        <div>
          {showAssignContent && (
            <span className="mr-8">
              <AssignContent
                assignContent={assignContent}
                setAssignContent={setAssignContent}
              />
            </span>
          )}
          <Button small onClick={() => addGuest(user.id, assignContent)}>
            {t(
              'in_person_training.event_overview.attendance.add_to_guest_list',
            )}
          </Button>
        </div>
        {attendanceErrors[user.id] && attendanceErrors[user.id].length > 0 && (
          <div className="w-fill ErrorContainer ErrorContainer--brandRed mt-8">
            {t(
              'in_person_training.event_overview.attendance.error_please_refresh',
            )}
          </div>
        )}
      </Table.Body.Cell>
    </Table.Row>
  );
};

UnregisteredRow.propTypes = {
  addGuest: PropTypes.func.isRequired,
  associatedContent: AssociatedContent,
  attendanceErrors: PropTypes.shape({}),
  event: types.Event,
  user: types.UnregisteredUser.isRequired,
};

export default UnregisteredRow;
